module.exports = __webpack_public_path__ + "img/media__video-icon.58d50c74.svg";